import React, { FC } from 'react';
import styles from '../journey-explorer.module.scss';
import { FilterPill, formatNumber } from '../journey-explorer-utils';
import { Dot } from './filter-group';

interface ActiveFiltersBarProps {
	matchCount: number | null;
	pills: FilterPill[];
	onRemove: (pill: FilterPill) => void;
	onClearAll: () => void;
}

const ActiveFiltersBar: FC<ActiveFiltersBarProps> = ({ matchCount, pills, onRemove, onClearAll }) => (
	<div className={styles.filters_bar}>
		{matchCount !== null && <span className={styles.match_count}>{formatNumber(matchCount)} customers match</span>}
		{pills.map((pill) => (
			<span key={pill.key} className={styles.pill}>
				<Dot color={pill.color} size={6} />
				{pill.label}
				<button type="button" className={styles.pill_remove} aria-label={`Remove ${pill.label}`} onClick={() => onRemove(pill)}>
					✕
				</button>
			</span>
		))}
		<button type="button" className={styles.clear_all} onClick={onClearAll}>
			Clear all
		</button>
	</div>
);

export default ActiveFiltersBar;
